export type SpacingLevel = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 16;

type SpacingProps = {
  level?: SpacingLevel;
}

const spacingXByLevel: { [index: number]: string } = {
  1: "pr-1 w-1",
  2: "pr-2 w-2",
  3: "pr-3 w-3",
  4: "pr-4 w-4",
  5: "pr-5 w-5",
  6: "pr-6 w-6",
  7: "pr-7 w-7",
  8: "pr-8 w-8",
  9: "pr-9 w-9",
  10: "pr-10 w-10",
  11: "pr-11 w-11",
  12: "pr-12 w-12",
  16: "pr-16 w-16",
};

const spacingYByLevel: { [index: number]: string } = {
  1: "pt-1 h-1",
  2: "pt-2 h-2",
  3: "pt-3 h-3",
  4: "pt-4 h-4",
  5: "pt-5 h-5",
  6: "pt-6 h-6",
  7: "pt-7 h-7",
  8: "pt-8 h-8",
  9: "pt-9 h-9",
  10: "pt-10 h-10",
  11: "pt-11 h-11",
  12: "pt-12 h-12",
  16: "pt-16 h-16",
};

export const SpacingX = ({ level = 6 }: SpacingProps) => <div className={spacingXByLevel[level]} />;

export const SpacingY = ({ level = 6 }: SpacingProps) => <div className={spacingYByLevel[level]} />;
